// src/components/image-dashboard/PreviewModal.jsx
const PreviewModal = ({ url, onClose }) => {
    if (!url) return null;
    return (
        <div className="modalOverlay" onClick={onClose}>
            <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                <img src={url} alt="preview" style={{ maxWidth: "80vw", maxHeight: "80vh" }} />
                <div style={{ marginTop: 10, textAlign: "right" }}>
                    <button onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default PreviewModal;
